import { createRouter, createWebHistory } from "vue-router";
import loginRoutes from './login.router.js';
import registerRoutes from './register.router.js';
import forgotpassRoutes from './forgotpass.router.js';
import verify from './verify.router.js';

import LogOutPage from "../components/Logout/LogOutPage.vue";
import { useAuthStore } from "@/store/index.js";


const routes = [
  ...loginRoutes,
  ...registerRoutes,
  ...forgotpassRoutes,
  ...verify,
  {
    path: "/logout",
    component: LogOutPage,
    meta: { layout: "default", title: 'Đăng xuất' },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach(async (to, from, next) => {
  // Kiểm tra nếu route yêu cầu đăng nhập và user chưa đăng nhập
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if(authStore.isAuthenticate){
    var result = await authStore.checkAccessToken();
    if(result.ResponseCode <= 0){
      await authStore.clearData();
    }
  }

  if (requiresAuth) {
    if(!authStore.isAuthenticate){
      // Redirect về trang home
      next("/")
      return;
    }
    
  } else {
    document.title =`${to.meta.title}`;
  }
  next();
});

export default router;
